import { BaseOapStatus } from '@/classes/SubmissionStatuses/BaseOapStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class MalformedResponseStatus extends BaseOapStatus {
	getStatusText() {
		return 'Malformed Response'
	}

	getToolTipText() {
		return {
			title: this.submissionStatus.provider + ' ' + this.getStatusText(),
			body: `The ${this.submissionStatus.provider} submission has failed, and returned a response that Sales Studio does not recognize. Please contact salesstudio@precoa.com.`,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
